import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from '../core/http/http.service';
//import { SystemTable, ISystemTable } from '../_entities';
//import { SystemTableMenuService } from './system-table-menu.service';
import * as _ from "lodash";

import { AuthenticationService } from '../_services/authentication/authentication.service';


interface MenuResult {
	totalStores: number;
	countries: {
		name: string;
		storeCount: number,
		regions: {
			name: string;
			storeCount: number,
			cities: {
				name: string;
				storeCount: number,
				stores: {
					storeNbr: number,
					storeCode: string,
					id: string;
					name: string;
					status: string;
				}[];
			}[];
		}[];
	}[],

	ownRegion: {
		name: string;
		storeCount: number,
		regions: {
			name: string;
			storeCount: number,

			stores: {
				storeNbr: number,
				storeCode: string,
				id: string;
				name: string;
				status: string;

			}[];
		}[];
	}[],

	projects: {
		key: string;
		projectCount: number;
		quarters: {
			key: string;
			projects: {
				id: string;
				name: string;
				storeId: number;
			}[];
		}[];
	}[],

	contracts: any[];
}

@Injectable()
export class MainMenuService {

	constructor(
		public readonly httpService: HttpService,
		public readonly router: Router,
		public readonly route: ActivatedRoute,
		public auth: AuthenticationService
	) { }

	getMenu(query?: string): Promise<Menu> {
		return new Promise((resolve, reject) => {

			var menuUrl;
			var storeFolderName;
			var storeFolderIcon;

			if (!!query) {
				storeFolderIcon = "magnifier";
				storeFolderName = `Results for ${query}`;
				menuUrl = `api/menu/search?query=${query}`;
			} else {
				storeFolderIcon = "basket";
				storeFolderName = "Stores";
				menuUrl = 'api/menu';
			}

			this.httpService.get<MenuResult>(menuUrl)
				.then(result => {
					const menu = new Menu();

					if (!query) {
						menu.addMenuItem(new TopLevelMenuItem("Dashboard", "rocket", "blue", () => { this.router.navigate(['/dashboard']); }));

						if (this.auth.storeWriteAccess || this.auth.projectWriteAccess) {

							const processesMenuItem = new TopLevelMenuItem("Processes", "magic-wand", "purple");

							if (this.auth.projectWriteAccess) {
								processesMenuItem.addMenuItem(new MenuItem("New Store Project", () => { this.router.navigate(['process/new-store-project']); }));
							}

							menu.addMenuItem(processesMenuItem);

						}
					}


					const storeMenuItem = new TopLevelMenuItem(storeFolderName, storeFolderIcon, "red", null, result.totalStores);

					if (!!query) {
						storeMenuItem.toggleOpen();
					}

					if (!!result.countries) {
						for (let country of _.sortBy(result.countries, x => x.name)) {
							const countryItem = new MenuItem(country.name, null, null, country.storeCount);
							for (let region of _.sortBy(country.regions, x => x.name)) {
								const regionItem = new MenuItem(region.name, null, null, region.storeCount);
								countryItem.addMenuItem(regionItem);
								for (let city of _.sortBy(region.cities, x => x.name)) {
									const cityItem = new MenuItem(city.name, null, null, city.storeCount);
									regionItem.addMenuItem(cityItem);

									for (let store of city.stores) {
										const storeItem = new MenuItem(store.name,
											() => { this.router.navigate(['store', store.id]); },
											{ routeId: 'store', id: store.id }, store.status);
										cityItem.addMenuItem(storeItem);
									}
								}
							}

							storeMenuItem.addMenuItem(countryItem);
						}
					} else if (!!result.ownRegion) {
						for (let country of _.sortBy(result.ownRegion, x => x.name)) {
							const countryItem = new MenuItem(country.name, null, null, country.storeCount);
							for (let region of _.sortBy(country.regions, x => x.name)) {
								const regionItem = new MenuItem(region.name, null, null, region.storeCount);
								countryItem.addMenuItem(regionItem);
								for (let store of _.sortBy(region.stores, x => x.name)) {

									const storeItem = new MenuItem(store.name,
										() => { this.router.navigate(['store', store.id]); },
										{ routeId: 'store', id: store.id }, store.status);
									regionItem.addMenuItem(storeItem);

								}
							}

							storeMenuItem.addMenuItem(countryItem);
						}
					}

					menu.addMenuItem(storeMenuItem);
					if (!query) {
						if (this.auth.projectAccess) {

							var numProjects = 0;

							for (let year of result.projects) {
								for (let quarter of year.quarters) {
									numProjects = numProjects + quarter.projects.length;
								}
							}

							const projectsMenuItem = new TopLevelMenuItem("Projects", "pin", "orange", null, numProjects);
							for (let year of result.projects) {
								const yearItem = new MenuItem(year.key, null, null, year.projectCount);

								for (let quarter of year.quarters) {
									const quarterItem = new MenuItem(quarter.key, null, null, quarter.projects.length);
									yearItem.addMenuItem(quarterItem);

									for (let project of quarter.projects) {
										const projectItem = new MenuItem(project.name,
											() => {
												this.router.navigate(['store', project.storeId, 'project', project.id]);
											},
											{ routeId: 'project', id: project.storeId + "_" + project.id });
										quarterItem.addMenuItem(projectItem);
									}
								}
								projectsMenuItem.addMenuItem(yearItem);
							}
							menu.addMenuItem(projectsMenuItem);
						}


						if (this.auth.centralContractAccess) {
							menu.addMenuItem(new TopLevelMenuItem("Central contracts",
								"docs",
								"green",
								() => { this.router.navigate(['/central-contract']); }));
						}

						const reportsMenuItem = new TopLevelMenuItem("Reports", "pie-chart", "grey");

						if (this.auth.projectAccess) {
							reportsMenuItem.addMenuItem(new MenuItem("Deliverables Info", () => { this.router.navigate(['report/deliverables-info']); }));
						}

						if (this.auth.contractAccess || this.auth.centralContractAccess) {
							reportsMenuItem.addMenuItem(new MenuItem("Contracts Info", () => { this.router.navigate(['report/contract-info']); }));
						}

						if (this.auth.contractAccess) {
							reportsMenuItem.addMenuItem(new MenuItem("IFRS Report", () => { this.router.navigate(['report/ifrs']); }));
						}

						if (this.auth.projectAccess) {
							reportsMenuItem.addMenuItem(new MenuItem("Projects Info", () => { this.router.navigate(['report/project-key-info']); }));
						}
						
						if(this.auth.storeWriteAccess) {
							reportsMenuItem.addMenuItem(new MenuItem("Store Info ", () => { this.router.navigate(['report/store-info']); }));
							reportsMenuItem.addMenuItem(new MenuItem("Store Planner Info ", () => { this.router.navigate(['report/store-planner-info']); }));
						}

						if(reportsMenuItem.items && reportsMenuItem.items.length) {
							menu.addMenuItem(reportsMenuItem);
						}

						const userMenuItem = new TopLevelMenuItem(this.auth.authenticatedUser ? this.auth.authenticatedUser.fullName ? this.auth.authenticatedUser.fullName : this.auth.authenticatedUser.name : "Unknown", "user", "user-menu");

						userMenuItem.addMenuItem(new MenuItem("Settings", () => { this.router.navigate(['/user-settings']); }));

						userMenuItem.addMenuItem(new MenuItem("Log out",
							() => {
								this.auth.logOut();
								this.router.navigateByUrl('/login');
							}));

						userMenuItem.addMenuItem(new MenuItem("Info", () => { this.router.navigate(['/user-details']); }));


						menu.addMenuItem(userMenuItem);

						if (this.auth.administrator) {

							const adminMenuItem = new TopLevelMenuItem("Administration", "settings", "");


							adminMenuItem.addMenuItem(new MenuItem("Add Existing Store", () => { this.router.navigate(['process/new-store']); }));

							adminMenuItem.addMenuItem(new MenuItem("System Tables", () => { this.router.navigate(['administration/systemtables']); }));
							adminMenuItem.addMenuItem(new MenuItem("Tags", () => { this.router.navigate(['administration/tags']); }));

							adminMenuItem.addMenuItem(new MenuItem("Users", () => { this.router.navigate(['administration/users']); }));
							adminMenuItem.addMenuItem(new MenuItem("Consumer Price Index", () => { this.router.navigate(['administration/cpi']); }));
							adminMenuItem.addMenuItem(new MenuItem("Suppliers", () => { this.router.navigate(['administration/suppliers']); }));
							adminMenuItem.addMenuItem(new MenuItem("Contacts", () => { this.router.navigate(['administration/contacts']); }));
							adminMenuItem.addMenuItem(new MenuItem("Demarcation List", () => { this.router.navigate(['administration/demarcation']); }));
							menu.addMenuItem(adminMenuItem);

						}
					}


					resolve(menu);

				}, error => reject(error));
		});

	}



	//getSystemTableMenu(menu: MenuItem): Promise<void> {
	//    return this.systemTableMenuService.getItems()
	//        .then((systemTables: ISystemTable[]) => {
	//            const groups = _.uniqBy(systemTables, e => e.group);
	//            _.each(groups,
	//                group => {
	//                    var groupMenu = new MenuItem(group.group);
	//                    const items = _.filter(systemTables, { group: group.group });

	//                    _.each(items,
	//                        item => {
	//                            groupMenu.addMenuItem(new MenuItem(item.title, () => this.navigateToSystemTable(item)));
	//                        });

	//                    menu.addMenuItem(groupMenu);

	//                });

	//        });
	//}

	//private navigateToSystemTable(systemTable: ISystemTable): void {
	//    this.router.navigate(['administration/systemtable', SystemTable[systemTable.systemTable]]);
	//}

}
export abstract class MenuBase<T extends MenuItem> {
	protected currentItem: T;

	addMenuItem(item: T) {
		item.parent = this;
		this.items.push(item);
		item.onToggle(opened => {
			if (item.isOpen) {
				if (this.currentItem) {
					this.currentItem.toggleOpen();
				}
				this.currentItem = item;
			} else {
				this.currentItem = null;
			}
		})
		return this;
	}

	items: T[] = [];
	parent: MenuBase<T>;
}

export class Menu extends MenuBase<TopLevelMenuItem> {
	private indexedItems = {};

	addMenuItem(item: TopLevelMenuItem) {
		this.indexItem(item);
		return super.addMenuItem(item);
	}

	findItemById(routeId: string, id: string) {
		return this.indexedItems[routeId + '_' + id];
	}

	private indexItem(item: MenuItem) {
		if (item.data && item.data['routeId']) {
			this.addItem(item);
		}
		item.items.forEach(x => this.indexItem(x));
	}
	private addItem(item: MenuItem) {
		this.indexedItems[item.data['routeId'] + '_' + item.data['id']] = item;
	}
}

export class MenuItem extends MenuBase<MenuItem> {
	private onToggleCallback: (item: MenuItem) => void;

	constructor(public name: string, private onNavigate?: () => void, public data: any = null, public badge?: any) {
		super();
	}

	click(currentItem) {

		this.toggleOpen();

		if (!!this.onNavigate) {
			this.onNavigate();
		}
	}

	open() {
		if (!this.isOpen) {
			this.toggleOpen();
		}
	}
	onToggle(callback: (item: MenuItem) => void) {
		this.onToggleCallback = callback;
	}
	toggleOpen() {

		this.isOpen = !this.isOpen;
		if (this.onToggleCallback) {
			this.onToggleCallback(this);
		}
		if (this.isOpen) {
			if (this.parent instanceof MenuItem) {
				this.parent.open();
			}
		} else {
			if (this.currentItem) {
				this.currentItem.toggleOpen();
				this.currentItem = null;
			}
		}
	}

	isOpen: boolean = false;
}

export class TopLevelMenuItem extends MenuItem {
	constructor(name: string, public icon: string, public color: string, onNavigate?: () => void, badge?: any) {
		super(name, onNavigate, null, badge);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shell/main-menu.service.ts